import gql from 'graphql-tag';

export default gql`
    mutation AddProppant($input: ProppantAddRequest) {
        addProppant(input: $input) {
            errors
            createdProppantId
        }
    }
`;
